import { FC } from "react"
import { FilesUpload } from "../../../module/external/containers/filesUpload"

export const FilesUploadPage: FC = () => <FilesUpload />
